import {
  DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_BEGIN,
  DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_SUCCESS,
  DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_FAILURE,
  DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
export function supabaseUpdateCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/supabase/update-collection`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_SUCCESS,
            data: res.data,
          });
          toast.success('Updated Successfully !');
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_FAILURE,
            data: { error: err },
          });
          toast.error(`Updation Failed !`);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissSupabaseUpdateCollectionError() {
  return {
    type: DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_BEGIN:
      return {
        ...state,
        supabaseUpdateCollectionPending: true,
        supabaseUpdateCollectionError: null,
      };

    case DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_SUCCESS:
      return {
        ...state,
        supabaseUpdateCollectionPending: false,
        supabaseUpdateCollectionError: null,
      };

    case DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_FAILURE:
      return {
        ...state,
        supabaseUpdateCollectionPending: false,
        supabaseUpdateCollectionError: action.data.error,
      };

    case DATA_CONNECTOR_SUPABASE_UPDATE_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        supabaseUpdateCollectionError: null,
      };

    default:
      return state;
  }
}
